import { ReadonlyURLSearchParams } from 'next/navigation';
import { urlParameterCodes } from '@/constants/urlParams';

export const getManufacturerFromParam = (searchParams: ReadonlyURLSearchParams) =>
  searchParams.get(urlParameterCodes.productDetail.doorKnob);
